import Link from 'next/link'
import LogoSvg from '../svg/logo'

export default function Logo() {
  return (
    <div className='root'>
      <Link legacyBehavior href='/'>
        {/* <a aria-label='DrivrzXchange'>
          <LogoSvg />
        </a> */}
        <img
          src='/images/privauto-icon.png'
          alt='Privauto icon'
          width='200'
        />
      </Link>

      <style jsx>{`
        .root {
          a {
            display: inline-block;
          }

          :global(svg) {
            max-width: 25rem;
            width: 100%;
          }
        }
      `}</style>

      <style jsx>{`
        @media (max-width: 1024px) {
          .root {
            :global(img) {
              max-width: 12.7rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
